const header = require('./includes/header');
const homePage = require('./pages/homepage');
const news = require('./pages/news');
const filterPlate = require('./includes/filter-plate');

$("document").ready(function () {
  header();
  homePage();
  news();
  filterPlate();

  chooseExcludeNumber();
  fnQuickSearch();
  fnSearch();
  chooseTypePlate();
  
  // Kiểm tra và điều chỉnh footer position
  adjustFooterPosition();
})

const chooseTypePlate = () => {
  $('.g-type-plate button').click(function () {
    $('.g-type-plate button').removeClass('active');
    $(this).addClass('active');
    const type = $(this).data('type');
    const searchParams = new URLSearchParams(window.location.search);

    if (searchParams.has('type')) {
      if (type) searchParams.set('type', type);
      else searchParams.delete('type');
    }
    else {
      if (type) searchParams.append('type', type);
    }

    window.location.href = `${window.location.pathname}?${searchParams.toString()}`;
  })
}

const chooseExcludeNumber = () => {
  $(".fate .item").click(function () {
    if($(this).hasClass("active")) {
      $(this).removeClass("active");
    }
    else $(this).addClass("active");
  });
}

const fnSearch = () => {
  $('.button-find').click(function () {
    const keyword = $('.g-input input[name="keyword"]').val();
    const prefix = $('.item-icon').find(":selected").val();
    const excludedNumbers = $('.fate .item').not('.active').map(function () {
      return $(this).data('value');
    }).get().join(',');
    const province = $('select[name="province[]"]').val().join(',');
    const minPrice = $('input[name="minPrice"]').val();
    const maxPrice = $('input[name="maxPrice"]').val();
    const params = {
      minPrice, maxPrice,
      keyword, prefix, 
      excludedNumbers, province, page: 1
    }
    const searchParams = new URLSearchParams(window.location.search);

    for(let key of ['keyword', 'prefix', 'province', 'excludedNumbers', 'minPrice', 'maxPrice', 'page']) {
      if (searchParams.has(key)) {
        if(params[key]) searchParams.set(key, params[key]);
        else searchParams.delete(key);
      }
      else {
        if(params[key]) searchParams.append(key, params[key]);
      }
    }

    window.location.href = `/tim-kiem?${searchParams.toString()}`;
  })
}

const fnQuickSearch = () => {
  $('#filter-tags .item').click(function () {
    $("#filter-tags .item").removeClass("active");
    $(this).addClass("active");
    const tags = $(this).data('value');
    const searchParams = new URLSearchParams(window.location.search);

    if(searchParams.has('tags')) {
      if(tags) searchParams.set('tags', tags);
      else searchParams.delete('tags');
    }
    else {
      if(tags) searchParams.append('tags', tags);
    }

    window.location.href = `/tim-kiem?${searchParams.toString()}`;
  })

  $('#filter-price').change(function () {
    const sort = $(this).val();
    const searchParams = new URLSearchParams(window.location.search);

    if(searchParams.has('sortPrice')) {
      if(sort) searchParams.set('sortPrice', sort);
      else searchParams.delete('sortPrice');
    }
    else {
      if(sort) searchParams.append('sortPrice', sort);
    }

    window.location.href = `/tim-kiem?${searchParams.toString()}`;
  })

  $('#filter-code').change(function () {
    const sort = $(this).val();
    const searchParams = new URLSearchParams(window.location.search);

    if(searchParams.has('sortCode')) {
      if(sort) searchParams.set('sortCode', sort);
      else searchParams.delete('sortCode');
    }
    else {
      if(sort) searchParams.append('sortCode', sort);
    }

    window.location.href = `/tim-kiem?${searchParams.toString()}`;
  })
}

$(window).resize(function () {
  // Điều chỉnh footer position khi resize window
  adjustFooterPosition();
})

// Hàm kiểm tra và điều chỉnh footer position
const adjustFooterPosition = () => {
  const windowHeight = $(window).height();
  const documentHeight = $(document).height();
  const footer = $('.footer');
  
  // Nếu chiều cao của document nhỏ hơn hoặc bằng chiều cao của window
  // thì footer sẽ được fixed ở bottom
  if (documentHeight <= windowHeight) {
    footer.addClass('footer-fixed');
  } else {
    footer.removeClass('footer-fixed');
  }
}
